export const getStatusColor = (status: string): 'default' | 'success' | 'error' => {
  switch (status) {
    case 'active':
      return 'success';
    case 'inactive':
      return 'error';
    default:
      return 'default';
  }
};

export const getStatusLabel = (status: string) => {
  switch (status) {
    case 'active':
      return '利用中';
    case 'inactive':
      return '停止中';
    default:
      return status;
  }
};
